import { useClipboard } from '@vueuse/core';
import { watch } from 'vue';

import { toast } from '@ui/components/sonner';

/**
 * Wraps VueUse's `useClipboard` and fires a confirmation toast on a successful
 * copy. Use for click-to-copy on inline text where the full `CopyButton`
 * (with its button chrome + icon) isn't wanted.
 */
export function useCopyToClipboard() {
  const clipboard = useClipboard();

  watch(clipboard.copied, (copied) => {
    if (copied) {
      toast.info('Copied to clipboard');
    }
  });

  return clipboard;
}
